import {useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {
  selectExpiringUserData,
  selectExpiringUserLoading,
  selectExpiringUserError,
  setExpiringUserData,
  setExpiringUserLoading,
  setExpiringUserError
} from '../slices/expiringUserSlice'
import queryExpiringUser from '../../api/queries/queryExpiringUsers'

export const useExpiringUser = () => {
  const dispatch = useDispatch()
  const data = useSelector(selectExpiringUserData)
  const loading = useSelector(selectExpiringUserLoading)
  const error = useSelector(selectExpiringUserError)

  // Fetch data from GraphQL query
  const queryResult = queryExpiringUser()

  // Sync query results to Redux store
  useEffect(() => {
    if (queryResult.data !== undefined) {
      dispatch(setExpiringUserData(queryResult.data))
    }
  }, [queryResult.data, dispatch])

  useEffect(() => {
    if (queryResult.loading !== undefined) {
      dispatch(setExpiringUserLoading(queryResult.loading))
    }
  }, [queryResult.loading, dispatch])

  useEffect(() => {
    if (queryResult.error !== undefined) {
      dispatch(setExpiringUserError(queryResult.error))
    }
  }, [queryResult.error, dispatch])

  return {data, loading, error}
}
